<div class="form-row">
    <div [formGroup]="oemForm" class="w-100">
        <h2 style="">Add OEM </h2>
        <div class="row">
        <div class="form-row " style="padding: 10px; padding-bottom: 0px;">


            <div class="col-lg-11" style="    margin-bottom: 22px; width: 89%;">
                <div>
                    <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color profil-align">
                        {{oemForm.get('logo')?.value == null?'Company':''}} Logo</p>
                </div>
                <div class="card" *ngIf="oemForm.get('logo')?.value == null" (dragover)="onDragOver($event)" (drop)="uploadLogo($event, true)">
                    <input class="d-none" type="file" id="upload" accept=".png,.jpg,.jpeg,.svg"
                        (change)="uploadLogo($event, false)" />
                    <label class="d-flex justify-content-center text " for="upload" mat-raised-button>
                        <img alt="" style="margin-top: -4px;" src="./../../assets/images/photo-add.svg">Drag files
                        here to upload (or) <span style="text-decoration: underline;"> Select Files</span>
                    </label>
                </div>
               
                <div class="card" *ngIf="oemForm.get('logo')?.value !== null">
                    <div class="row  ">
                        <div class="col-lg-12 p-4 d-flex  justify-content-between">
                            <img alt="" class="profile_pic" loading="eager"
                                [src]="oemForm.get('logo')?.value">
                            <mat-icon class="my-3 close" (click)="clearProfile()">close</mat-icon>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-5">
                <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" >First Name<span class="text-danger">*</span></p>
                <mat-form-field appearance="outline" class="w-100">
                    <input matInput formControlName="firstName" placeholder="First Name" class="inputs">
                    <mat-error class="error-message image-error" *ngIf="oemForm.get('firstName')?.invalid">
                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> First Name is required
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-md-5 ">
                <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" >Last Name<span class="text-danger">*</span></p>
                <mat-form-field appearance="outline" class=" w-100">
                    <input matInput formControlName="lastName" placeholder="Last Name" class="inputs">
                    <mat-error class="error-message image-error" *ngIf="oemForm.get('lastName')?.invalid">
                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Last Name is required
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-md-5">
                <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" >Company Name<span class="text-danger">*</span></p>
                <mat-form-field appearance="outline" class="w-100">
                    <input #checkCompanyName matInput formControlName="companyName" placeholder="Company Name" class="inputs" (input)="isInputChange($event)" (change)="isFocusOff($event)" (blur)="isFocusOut($event)" (focus)="isFocusOn($event)" (click)="editEvent()">
                    <mat-error class="error-message image-error" *ngIf="oemForm.get('companyName')?.invalid">
                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Company Name is required
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-md-5 ">
                <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" >Company Email<span class="text-danger">*</span></p>
                <mat-form-field appearance="outline" class=" w-100">
                    <input #checkEmailField matInput formControlName="email" placeholder="Company Email" class="inputs" (change)="isFocusOffEmail($event)" (input)="isInputChangeEmail($event)">
                    <mat-error class="error-message image-error" *ngIf="oemForm.get('email')?.invalid">
                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Company email is required
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-5">
                <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" >Phone Number<span class="text-danger">*</span></p>
                <mat-form-field appearance="outline" class="w-100">
                    <input matInput formControlName="phoneNumber" placeholder="Phone Number" class="inputs" onlyNumbers minlength="10" maxlength="15">
                    <mat-error class="error-message image-error" *ngIf="oemForm.get('phoneNumber')?.invalid">
                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Phone Number is required
                    </mat-error>
                </mat-form-field>
            </div>
          
            <div class="col-md-5 ">
                <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0" >Website URL<span class="text-danger">*</span></p>
                <mat-form-field appearance="outline" class=" w-100">
                    <input matInput formControlName="website" placeholder="Website URL" class="inputs">
                    <mat-error *ngIf="oemForm.get('website')?.invalid || oemForm.get('website')?.hasError('pattern')">
                        <img class="error-icon"
                            loading="eager" alt="" src="./../../assets/images/alert.svg" />Enter a valid URL 
                      </mat-error>
                </mat-form-field>
            </div>

        </div>
        </div>
        <div class="form-rows" style="gap: 0.8rem; margin-left: 1.35rem; margin-top: -5px;" >

            <button  class="mwe-button mwe-button--primary m-3" (click)="save()" >Save OEM</button>
            <button class="mwe-button mwe-button--primary m-3" (click)="cancel()" >Cancel</button>
        </div>

    </div>
</div>